import React from 'react';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { motion, AnimatePresence } from 'framer-motion';
import { format } from 'date-fns';
import { LuEyeOff } from 'react-icons/lu';
import useNotificationStore from '@/stores/notificationStore';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@components/common/Accordion';

export const Notifications = React.memo(() => {
    const { notifications, removeNotification, clearNotifications } = useNotificationStore();

    const handleClearAllNotifications = () => {
        clearNotifications();
    };

    const groupedNotifications = notifications.reduce((acc, notification) => {
        const date = format(new Date(notification.createdAt), 'yyyy-MM-dd');
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(notification);
        return acc;
    }, {});

    return (
        <NavigationMenu.Content className="z-[9999] absolute top-full right-0 min-w-[400px] h-[400px] overflow-y-scroll bg-white rounded-md shadow-md p-4">
            <div className="flex items-center justify-between mb-4">
                <p className="text-lg leading-8 font-bold">Recent notifications:</p>
                <div className="flex items-center gap-2">
                    <p
                        onClick={handleClearAllNotifications}
                        className="text-xs text-primary-blue hover:text-blue-500 cursor-pointer font-bold flex items-center"
                    >
                        Clear All
                    </p>
                </div>
            </div>

            <AnimatePresence>
                {Object.entries(groupedNotifications).map(([date, dateNotifications]) => (
                    <motion.div
                        key={date}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        className="mb-4"
                    >
                        <p className="text-sm text-gray-500 mb-2">
                            {format(new Date(date), 'MMMM d, yyyy')}
                        </p>
                        <Accordion type="single" collapsible className="w-full space-y-2">
                            {dateNotifications.map(notification => (
                                <AccordionItem
                                    key={notification.id}
                                    value={notification.id}
                                    className={`notification-${notification.type} rounded-md`}
                                >
                                    <AccordionTrigger className="px-4 py-2">
                                        {notification.title}
                                    </AccordionTrigger>
                                    <AccordionContent className="pb-2 px-4">
                                        <p className="text-xs text-gray-500 pb-2 border-b border-gray-200 mb-1">
                                            {notification.message}
                                        </p>
                                        <div className="flex items-center justify-between mt-2">
                                            <div
                                                className="flex items-center gap-1 text-gray-300 hover:text-gray-500 cursor-pointer"
                                                onClick={() => removeNotification(notification.id)}
                                            >
                                                <p className="font-bold text-sm">Hide</p>
                                                <LuEyeOff className="h-4 w-4" />
                                            </div>

                                            {/* {notification.onClick && (
                                                <p
                                                    onClick={notification.onClick}
                                                    className="text-xs text-primary-blue hover:text-blue-500 cursor-pointer font-bold flex items-center"
                                                >
                                                    View Detail
                                                    <MdArrowForwardIos className="inline-block ml-1 text-sm" />
                                                </p>
                                            )} */}
                                        </div>
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </motion.div>
                ))}
            </AnimatePresence>

            {notifications.length === 0 && (
                <div className="flex items-center justify-center h-32">
                    <p className="text-gray-500">No notifications</p>
                </div>
            )}
        </NavigationMenu.Content>
    );
});

Notifications.displayName = 'Notifications';
